import { keyframes, css } from 'styled-components';
import { toastPositions } from './positions';
const fadeIn = /*#__PURE__*/keyframes(["from{opacity:0;}to{opacity:1;}"]);
const slideInRight = /*#__PURE__*/keyframes(["from{transform:translateX(-50%);}to{transform:translateX(0);}"]);
const slideInLeft = /*#__PURE__*/keyframes(["from{transform:translateX(50%);}to{transform:translateX(0);}"]);

const animationStyle = position => {
  switch (position) {
    case toastPositions.TOP:
      return css(["", " 150ms ease-out"], fadeIn);

    case toastPositions.TOP_LEFT:
      return css(["", " 150ms ease-out,", " 150ms ease-out"], fadeIn, slideInRight);

    case toastPositions.TOP_RIGHT:
      return css(["", " 150ms ease-out,", " 150ms ease-out"], fadeIn, slideInLeft);

    case toastPositions.BOTTOM:
      return css(["", " 150ms ease-out"], fadeIn);

    case toastPositions.BOTTOM_LEFT:
      return css(["", " 150ms ease-out,", " 150ms ease-out"], fadeIn, slideInRight);

    case toastPositions.BOTTOM_RIGHT:
      return css(["", " 150ms ease-out,", " 150ms ease-out"], fadeIn, slideInLeft);

    default:
      return css(["", " 150ms ease-out"], fadeIn);
  }
};

export { animationStyle };